// extracted by mini-css-extract-plugin
export default {"empty":"Price_empty__3miHZ","fill":"Price_fill__m6NRd"};